module.exports = __webpack_public_path__ + "static/img/luxiangjilu.50c9c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/luxiangjilu.png
// module id = Nl1P
// module chunks = 24